import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./AllCategories.css";

export default function AllCategories() {
  const [selectedSection, setSelectedSection] = useState(null);

  // Data for each category section
  const categories = [
    {
      title: "Shop by Health Concerns",
      icon: "bi-heart-pulse-fill",
      color: "text-danger",
      subcategories: [
        "Heart Health",
        "Eye Care",
        "Respiratory Health",
        "Fever & Cold",
      ],
    },
    {
      title: "Full Body Health Checkups",
      icon: "bi-person-heart",
      color: "text-primary",
      subcategories: [
        "Basic Checkup",
        "Advanced Checkup",
        "Women’s Health",
        "Men’s Health",
      ],
    },
    {
      title: "Featured Brands",
      icon: "bi-capsule",
      color: "text-success",
      subcategories: ["Himalaya", "Dabur", "Dr. Morepen", "Patanjali"],
    },
    {
      title: "Personal Care",
      icon: "bi-person-bounding-box",
      color: "text-warning",
      subcategories: [
        "Skin Care",
        "Hair Care",
        "Body Care",
        "Sun Protection",
      ],
    },
    {
      title: "Pathology Tests | Up to 70% Off",
      icon: "bi-eyedropper",
      color: "text-danger",
      subcategories: [
        "Blood Test",
        "Urine Test",
        "Kidney Function Test",
        "Liver Function Test",
      ],
    },
  ];

  return (
    <div className="container-fluid py-5">
      <h2 className="text-center fw-bold text-danger mb-5">
        All Health Categories
      </h2>

      {/* ✅ Category Sections */}
      <div className="row g-4 justify-content-center">
        {categories.map((section, index) => (
          <div key={index} className="col-lg-4 col-md-6">
            <div
              className="card text-center shadow-sm p-4 border-0"
              style={{ cursor: "pointer", borderRadius: "15px" }}
              onClick={() =>
                setSelectedSection(
                  selectedSection === index ? null : index
                )
              }
            >
              <i
                className={`bi ${section.icon} ${section.color} fs-1 mb-3`}
              ></i>
              <h5 className="fw-bold text-dark">{section.title}</h5>
              <p className="text-muted small mb-0">
                Click to view related items
              </p>
            </div>

            {/* ✅ Show Subcategories dynamically */}
            {selectedSection === index && (
              <div className="mt-3">
                <div className="card border-0 shadow-sm p-3">
                  <h6 className="fw-bold mb-3 text-danger">
                    Related Options:
                  </h6>
                  <ul className="list-unstyled mb-0">
                    {section.subcategories.map((item, i) => (
                      <li
                        key={i}
                        className="py-2 border-bottom d-flex align-items-center justify-content-between"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          alert(`You clicked: ${item}`)
                        }
                      >
                        <span>{item}</span>
                        <i className="bi bi-chevron-right text-secondary"></i>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
